import React, { useState } from "react"
import styles from "./question.module.css"
import { checkAnswer } from "../utils/quizUtil"

const Button = props => {
  const [select, setSelect] = useState(false)
  const {
    qid,
    type,
    choice,
    answer,
    unlock,
    choiceIndex,
    answered,
    handleClick,
  } = props
  const qParams = { type, answer, choiceIndex, unlock }

  let buttonStyles = [styles.choice]
  if (select) {
    buttonStyles.push(styles.selected)
  } else {
    buttonStyles.push(styles.unselected)
  }
  if (answered) {
    const isCorrect = checkAnswer(qParams)
    if (isCorrect) {
      buttonStyles.push(styles.correct)
    } else {
      buttonStyles.push(styles.incorrect)
    }
  }

  return (
    <button
      className={buttonStyles.join(" ")}
      onClick={() => {
        if (handleClick) {
          if (!answered && !select) {
            setSelect(true)
            handleClick(qid, qParams)
          }
        }
      }}
      onKeyDown={() => {
        if (handleClick) {
          if (!answered && !select) {
            setSelect(true)
            handleClick(qid, qParams)
          }
        }
      }}
    >
      {choice}
    </button>
  )
}

export default props => {
  return props.choices.map((c, i) => (
    <Button
      qid={props.qid}
      type={props.type}
      choice={c}
      choiceIndex={i}
      answered={props.answered}
      answer={props.answer}
      unlock={props.unlock}
      handleClick={props.handleClick}
      key={i}
    />
  ))
}
